import { Component } from '@angular/core';

@Component({
  selector: 'app-cards1-examples-1',
  templateUrl: './cards1-examples-1.component.html'
})
export class Cards1Examples1Component {}
